"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52612],{

/***/ 52612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomAnimation": function() { return /* binding */ CustomAnimation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var hooks_useIntersectionItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30109);





var CustomAnimation = function(param) {
    var children = param.children, translateX = param.translateX, translateY = param.translateY, opasityDuration = param.opasityDuration, transformDuration = param.transformDuration, transitionDelay = param.transitionDelay, percentIntersection = param.percentIntersection;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,hooks_useIntersectionItem__WEBPACK_IMPORTED_MODULE_2__/* .useIntersectionItem */ .b)(percentIntersection), 2), intersectRef = ref[0], isIntersected = ref[1];
    var delayInSeconds = transitionDelay / 1000;
    var appearanceStyles = {
        opacity: "1",
        transform: "translate(0px, 0px)",
        transitionProperty: "opacity, transform",
        transitionTimingFunction: "cubic-bezier(0.165, 0.84, 0.44, 1), cubic-bezier(0.165, 0.84, 0.44, 1)",
        transitionDuration: "".concat(opasityDuration, "s, ").concat(transformDuration, "s"),
        transitionDelay: "".concat(delayInSeconds, "s")
    };
    var generalStyles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        opacity: "0",
        transform: "translate(".concat(translateX, ", ").concat(translateY, ")")
    }, isIntersected ? appearanceStyles : {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: intersectRef,
        style: generalStyles,
        children: children
    });
};
CustomAnimation.defaultProps = {
    translateX: "0",
    translateY: "10px",
    opasityDuration: 0.05,
    transformDuration: 0.1,
    transitionDelay: 500,
    percentIntersection: 0.2
};
CustomAnimation.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object).isRequired,
    translateX: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    translateY: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    opasityDuration: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    transformDuration: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    transitionDelay: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    percentIntersection: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
};


/***/ }),

/***/ 30109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useIntersectionItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80621);


var useIntersectionItem = function() {
    var percentIntersection = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.2;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isIntersected = ref[0], setIntersected = ref[1];
    var intersectRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var intersection = (0,react_use__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(intersectRef, {
        root: null,
        rootMargin: "0px",
        threshold: percentIntersection
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (intersectRef && intersectRef.current) {
            if (intersection && intersection.intersectionRatio >= percentIntersection) {
                setIntersected(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        intersection
    ]);
    return [
        intersectRef,
        isIntersected
    ];
};


/***/ }),

/***/ 80621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIntersection = function (ref, options) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function (entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function () {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [ref.current, options.threshold, options.root, options.rootMargin]);
    return intersectionObserverEntry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersection);


/***/ })

}]);